import { useState } from "react";
import { Modal } from "../shared/Modal";
import { FormInput } from "../shared/FormInput";
import { Button } from "../shared/Button";
import { useApiCall } from "../../lib/useToastError";
import { AdminOrgs } from "../../lib/apiTyped";
import type { AdminUserRow } from "./UserActionsMenu";

export function PromoteToOwnerModal({
  user,
  onClose,
  onDone,
}: {
  user: AdminUserRow;
  onClose: () => void;
  onDone: () => void;
}) {
  const [orgName, setOrgName] = useState("");
  const [busy, setBusy] = useState(false);
  const { run } = useApiCall();

  async function submit() {
    if (!orgName.trim() || busy) return;
    setBusy(true);
    const r = await run(
      () => AdminOrgs.promote(user.uid, orgName.trim()),
      { successMessage: `${user.email ?? user.uid} is now an owner.` },
    );
    setBusy(false);
    if (r) onDone();
  }

  return (
    <Modal onClose={onClose} maxWidth="28rem">
      <h2 className="text-xl font-black mb-2 pr-6 text-ink">Promote to owner</h2>
      <p className="text-sm text-ink-3 mb-5">
        Creates a new org with <strong>{user.email ?? user.uid}</strong> as
        owner. The org starts with no plan and no seats; assign them
        afterwards from the organization detail.
      </p>
      <FormInput
        label="Organization name"
        value={orgName}
        onChange={setOrgName}
        placeholder="Acme Corp"
      />
      <div className="mt-6 flex gap-3">
        <Button variant="primary" onClick={submit} disabled={busy || !orgName.trim()} fullWidth>
          {busy ? "Creating…" : "Create organization"}
        </Button>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
}
